/**
 * This will test if the requested type of storage is working
 * @return A boolean indicating whether the requested type of storage is working
 */
var testStorage = function (type) {
  var test = 'test';
  try {
    window[type].setItem(test, test);
    window[type].removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
};
/**
 * This will test if localStorage is working
 * @return A boolean indicating whether localstorage is working
 */
var testLocalStorage = function () {
  return testStorage('localStorage');
};
/**
 * This will test if sessionStorage is working
 * @return A boolean indicating whether sessionStorage is working
 */
var testSessionStorage = function () {
  return testStorage('sessionStorage');
};
/**
 * This boolean indicates whether a type of storage is possible or not
 */
var storagePossible = {
  localStorage: undefined,
  sessionStorage: undefined
};
/**
 * This will set a type of storage field with the provided data
 * @param key - The key to store the data at
 * @param data - The data to store
 * @param type - The type of storage to set
 */
var setStorage = function (key, data, type) {
  if (storagePossible[type] === undefined) {
    storagePossible[type] = testStorage(type);
  }
  if (storagePossible[type]) {
    window[type].setItem(key, JSON.stringify(data));
  }
};
/**
 * This will set a localStorage field with the provided data
 * @param key - The key to store the data at
 * @param data - The data to store
 */
var setLocalStorage = function (key, data) {
  setStorage(key, data, 'localStorage');
};
/**
 * This will set a sessionStorage field with the provided data
 * @param key - The key to store the data at
 * @param data - The data to store
 */
var setSessionStorage = function (key, data) {
  setStorage(key, data, 'sessionStorage');
};
/**
 * This will go into the requested type of storage and fetch the stored value when available
 * @param key - The key under which the data is stored
 * @param defaultResponse - The response to return when nothing is found
 * @param type - The type of store to use
 * @return An object containing the data fetched from local storage
 */
var getStorage = function (key, defaultReponse, type) {
  if (defaultReponse === void 0) {
    defaultReponse = {};
  }
  if (storagePossible[type] === undefined) {
    storagePossible[type] = testStorage(type);
  }
  if (storagePossible[type]) {
    var storageData = window[type].getItem(key);
    return storageData ? JSON.parse(storageData) : defaultReponse;
  }
  return defaultReponse;
};
/**
 * This will go into localStorage and fetch the stored value when available
 * @param key - The key under which the data is stored
 * @param defaultResponse - The response to return when nothing is found
 * @return An object containing the data fetched from local storage
 */
var getLocalStorage = function (key, defaultReponse) {
  if (defaultReponse === void 0) {
    defaultReponse = {};
  }
  return getStorage(key, defaultReponse, 'localStorage');
};
/**
 * This will go into sessionStorage and fetch the stored value when available
 * @param key - The key under which the data is stored
 * @param defaultResponse - The response to return when nothing is found
 * @return An object containing the data fetched from local storage
 */
var getSessionStorage = function (key, defaultReponse) {
  if (defaultReponse === void 0) {
    defaultReponse = {};
  }
  return getStorage(key, defaultReponse, 'sessionStorage');
};
/**
 * This will delete the local or session storage item where the name is key
 */
var removeStorage = function (key, type) {
  if (storagePossible[type] === undefined) {
    storagePossible[type] = testStorage(type);
  }
  if (storagePossible[type]) {
    window[type].removeItem(key);
  }
};
/**
 * This will go into localStorage and fetch the stored value when available
 * @param key - The key under which the data is stored
 */
var removeLocalStorage = function (key) {
  return removeStorage(key, 'localStorage');
};
/**
 * This will go into sessionStorage and fetch the stored value when available
 * @param key - The key under which the data is stored
 */
var removeSessionStorage = function (key) {
  return removeStorage(key, 'sessionStorage');
};

export { getLocalStorage, getSessionStorage, getStorage, removeLocalStorage, removeSessionStorage, removeStorage, setLocalStorage, setSessionStorage, setStorage, testLocalStorage, testSessionStorage, testStorage };
//# sourceMappingURL=storage.js.map
